import { DefaultButton, Description } from '@Atoms';
import { CloudDownload } from '@mui/icons-material';
import { ITicketMessage } from '@Types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FileButtonProps {
	file: ITicketMessage
}

const FileButton: React.FC<FileButtonProps> = (props) => {
	const { file } = props;
	const files = file?.files[0];
	const { t } = useTranslation('translations');
	// const fileName = file.files.url.split('/');
	const size = files?.size && files.size / 1000;
	return (
		<div>
			<Description fontSize={10} text={`${t('file')}: ${files?.originName || ''}`} />
			<br />
			<Description fontSize={10} text={`${t('description')}: ${files?.note || ''}`} />
			<br />
			<Description fontSize={10} text={`${t('size')}: ${size} kB`} />
			<br />
			<a href={files.url} target="_blank" style={{ textDecoration: 'none' }} rel="noreferrer">
				<DefaultButton color="secondary" title={t('download')} startIcon={<CloudDownload />} />
			</a>
		</div>
	);
};

export default FileButton;
